type CSVOptions<T extends object> = {
  columns: ReadonlyArray<keyof T>;
  headerMap?: Partial<Record<keyof T, string>>;
};

const csvEscape = (v: unknown) => {
  if (!['string', 'number', 'boolean'].includes(typeof v)) return '';
  const s = String(v);
  return /[",\r\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const recordsToCsv = <T extends object>(rows: T[], { columns, headerMap }: CSVOptions<T>) => {
  const delimiter = ',';
  const header = columns.map((k) => headerMap?.[k] ?? String(k));

  const lines = [
    header.map(csvEscape).join(delimiter),
    ...rows.map((r) => columns.map((k) => csvEscape((r as any)[k])).join(delimiter)),
  ];

  return lines.join('\r\n');
};
